/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.50
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {ChecklistPeriodDTO} from './ChecklistPeriodDTO';

/**
 * The AssessmentDTO model module.
 * @module model/AssessmentDTO
 * @version v0
 */
export class AssessmentDTO {
  /**
   * Constructs a new <code>AssessmentDTO</code>.
   * @alias module:model/AssessmentDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AssessmentDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AssessmentDTO} obj Optional instance to populate.
   * @return {module:model/AssessmentDTO} The populated <code>AssessmentDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AssessmentDTO();
      if (data.hasOwnProperty('fiscalYear'))
        obj.fiscalYear = ApiClient.convertToType(data['fiscalYear'], 'Number');
      if (data.hasOwnProperty('period'))
        obj.period = ChecklistPeriodDTO.constructFromObject(data['period']);
      if (data.hasOwnProperty('frozen'))
        obj.frozen = ApiClient.convertToType(data['frozen'], 'Boolean');
      if (data.hasOwnProperty('editable'))
        obj.editable = ApiClient.convertToType(data['editable'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Number} fiscalYear
 */
AssessmentDTO.prototype.fiscalYear = undefined;

/**
 * @member {module:model/ChecklistPeriodDTO} period
 */
AssessmentDTO.prototype.period = undefined;

/**
 * @member {Boolean} frozen
 */
AssessmentDTO.prototype.frozen = undefined;

/**
 * @member {Boolean} editable
 */
AssessmentDTO.prototype.editable = undefined;

